import React, { lazy, Suspense, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { EntityRef } from './entityRefs';

// Reutilizăm modalele existente, încărcate lazy (se descarcă doar la prima deschidere).
const ClientModalView = lazy(() => import('../../pages/clients/ModalView'));
const ActivityModal = lazy(() => import('../../pages/activities/ActivityModal'));

/**
 * Gazdă globală pentru deschiderea entităților menționate de asistent.
 * Ascultă evenimentul `assistant:open-entity` (emis de chip-urile din mesaje):
 *  - client   → modalul de vizualizare client (reutilizat)
 *  - activity → modalul de activitate (reutilizat, self-fetch după id)
 *  - booking  → navighează la /bookings/view/:id
 *  - container→ navighează la bookingul părinte (containerele se văd în tab-ul lui)
 */
const AssistantEntityHost: React.FC = () => {
  const navigate = useNavigate();
  const [clientId, setClientId] = useState<number | null>(null);
  const [showClient, setShowClient] = useState(false);
  const [activity, setActivity] = useState<{ id: number; clientId: number } | null>(null);
  const [showActivity, setShowActivity] = useState(false);

  useEffect(() => {
    const handler = (e: Event) => {
      const ref = (e as CustomEvent).detail as EntityRef;
      if (!ref) return;
      switch (ref.kind) {
        case 'client':
          if (ref.id) {
            setClientId(ref.id);
            setShowClient(true);
          }
          break;
        case 'activity':
          if (ref.id) {
            setActivity({ id: ref.id, clientId: ref.clientId || 0 });
            setShowActivity(true);
          }
          break;
        case 'booking':
          if (ref.id) navigate(`/bookings/view/${ref.id}`);
          break;
        case 'container':
          if (ref.bookingId) navigate(`/bookings/view/${ref.bookingId}`);
          break;
        case 'meeting':
          if (ref.id) navigate(`/crm/sedinte/${ref.id}`);
          break;
      }
    };
    window.addEventListener('assistant:open-entity', handler);
    return () => window.removeEventListener('assistant:open-entity', handler);
  }, [navigate]);

  return (
    <Suspense fallback={null}>
      {clientId != null && <ClientModalView key={`assistant-client-${clientId}`} id={clientId} showModal={showClient} setShowModal={setShowClient} />}
      {activity != null && <ActivityModal key={`assistant-activity-${activity.id}`} clientId={activity.clientId} id={activity.id} openModal={showActivity} setOpenModal={setShowActivity} onSave={() => undefined} />}
    </Suspense>
  );
};

export default AssistantEntityHost;
